import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=7004cb71&scoped=true"
import script from "./FiltersBar.vue?vue&type=script&lang=ts"
export * from "./FiltersBar.vue?vue&type=script&lang=ts"
import style0 from "./FiltersBar.scss?vue&type=style&index=0&id=7004cb71&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7004cb71",
  null
  
)

export default component.exports